import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

const CustomToolTip = ({ message }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <Tooltip interactive='true' disableTouchListener enterDelay={100} leaveDelay={200} title={message}
            placement="top" 
            arrow 
            className="username-tooltip"   
            open={showTooltip}
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)} >
            <img
            src={require('../../common/assets/img/help-tooltip.png')}
            alt='help-tooltip' 
            onClick={() => setShowTooltip(!showTooltip)}
            />
        </Tooltip>
    );
}

export default CustomToolTip;